import hero from "../../../Assets/img/figura-hero-02.svg";
import shape from "../../../Assets/img/shape02.svg";
import Asesoramiento from '../Components/Asesoramiento';
import useSEOConfig from '../../../hooks/seo/useSEOConfig';
import { Navbar } from "../Components/Navbar";
import { useConfig } from "../../../context/ConfigContext";
import { useLocation } from "react-router-dom";
import { buscarTextoSeo } from "../../../utils/buscarTextoSeo";

const DATA_CONTACTO = {
    AR: {
        telefono: "54 9 11 2835 7048",
        horario_ventas: "08:30 a 20:30hs",
        hoario_atencion: "09:00 a 18:00hs"
    },
    UY: {
        telefono: "598 92 281 806",
        horario_ventas: "08:30 a 20:30hs",
        hoario_atencion: "09:00 a 17:00hs"
    },
    BR: {
        telefono: "",
        horario_ventas: "",
        hoario_atencion: ""
    }
}
export const Contacto = () => {

    const { config } = useConfig();
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Atención al cliente Segurarse - Conocé nuestros canales",
            description: textoSeo?.description ?? "Nuestro equipo de asesores está a disposición para ayudarte en lo que necesités, contactános por tu canal de preferencia y despejá todas tus consultas",
            tituloCompleto: !!textoSeo,
            keywords:
                config.pais === "UY" ?
                    "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro online, Aseguradoras, Seguros mapfre, Seguro Sancor, Seguro San Cristobal, Seguro flota, Cotizar seguro"
                    : "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle:
                config.pais === "UY" ?
                    "Contacto Segurarse - Corredor de Seguros digital"
                    : "Contacto Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Nuestro equipo de asesores está a disposición para ayudarte en lo que necesités, contactános por tu canal de preferencia y despejá todas tus consultas",
            twitterTitle:
                config.pais === "UY" ?
                    "Contacto Segurarse - Corredor de Seguros digital"
                    : "Contacto Segurarse - Bróker integral de Seguros digitales",
            twitterDescription: "Nuestro equipo de asesores está a disposición para ayudarte en lo que necesités, contactános por tu canal de preferencia y despejá todas tus consultas"
        }
    )

    return (
        <>
            <Navbar rubro='auto' />
            <main>
                <div className="pt-50 pb-30 px-3 py-lg-80 position-relative">
                    <img className="d-none d-lg-block pos02" src={shape} />
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-6">
                                <h1 className="ff-mukta fw-bold fs-30 fs-lg-36 lh-lg-1 text-black text-center text-lg-start">Contacto</h1>
                                <p className="fs-16 fs-lg-20 text-black text-center text-lg-start mb-20 mb-lg-40">Tenemos un <b>equipo de asesores</b> dispuestos a contestar todas tus consultas. <br className="d-sm-none" />
                                    Elegí el canal que se adapte a vos.
                                </p>

                                <div className="mx-auto mx-lg-0 maxw-330p mb-25 mb-lg-40">
                                    <a href={`https://api.whatsapp.com/send/?phone=${DATA_CONTACTO[config.pais].telefono.replaceAll(" ", "")}&text&type=phone_number&app_absent=0`} target="_blank" rel='noreferrer' className="d-flex align-items-center py-2 px-12 border border-1 border-878FA3 rounded-3 shadow-2">
                                        <svg className="svg-icon me-2" width="27" height="27"><use xlinkHref="#whatsapp"></use></svg>
                                        <span className="fs-19 text-black fw-bold">
                                            +{DATA_CONTACTO[config.pais].telefono}
                                        </span>
                                    </a>

                                    <div className="mb-20 mb-lg-30"></div>

                                    {
                                        config.pais === "AR" &&
                                        <a href="tel:0810-444-7348" target='_blank' rel="noreferrer" className="d-flex align-items-center py-2 px-12 border border-1 border-878FA3 rounded-3 shadow-2">
                                            <svg className="svg-icon me-2" width="27" height="27"><use xlinkHref="#icon-tel-circle"></use></svg>
                                            <span className="fs-19 text-black fw-bold">0810-444-SEGURO (7348)</span>
                                        </a>
                                    }
                                </div>

                                <div className="fs-17 fs-lg-18">
                                    <b>Horarios de atención:</b><br />
                                    - Ventas: lunes a viernes <br className="d-sm-none" />de  {DATA_CONTACTO[config.pais].horario_ventas}.<br />
                                    - Atención al cliente: lunes a viernes <br className="d-sm-none" />de  {DATA_CONTACTO[config.pais].hoario_atencion}.
                                </div>
                            </div>
                            <div className="col-lg-6 text-center text-lg-end pt-4 pt-lg-0">
                                <img src={hero} className="fig-hero-contacto" />
                            </div>
                        </div>
                    </div>
                </div>

                <Asesoramiento />
            </main>
        </>
    )
}
